module.exports = __webpack_public_path__ + "04_mustache_brown.fcd37df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/04_mustache_brown.png
// module id = lOaC
// module chunks = 0